export default {
  app: {
    logo: 'SkyRadar Лого',
    notProvided: 'Не е предоставено',
    contactFormSubject: 'Контактна форма: ',
  },
  landing: {
    title: 'SkyRadar',
    subtitle: 'Решение за откриване на мълнии от корпоративен клас',
    description: 'SkyRadar предлага цялостна платформа за откриване и мониторинг на мълнии за бизнеси и организации. Нашата напреднала технология осигурява известия в реално време, детайлна аналитика и безпроблемна интеграция с вашите съществуващи системи, за да защити вашите активи, операции и персонал от опасности, свързани с мълнии.',
    features: {
      title: 'Ключови функции',
      subtitle: 'Разгледайте мощните функции, които отличават нашата платформа',
      map: 'Мониторинг в реално време',
      mapDescription: 'Проследявайте ударите от мълнии в момента на тяхното възникване с нашата високопрецизна система за откриване',
      filter: 'Разширена аналитика',
      filterDescription: 'Получете ценни прозрения с анализ на исторически данни и персонализирани отчети',
      location: 'Незабавни известия',
      locationDescription: 'Получавайте незабавни известия, когато мълния застрашава вашата зона на интерес',
      theme: 'Безпроблемна интеграция',
      themeDescription: 'Свържете се с вашите съществуващи системи и работни процеси за унифицирано решение',
    },
    ctaButton: 'Изтеглете приложението',
    mobileApp: {
      title: 'Мобилно приложение SkyRadar',
      subtitle: 'Бъдете защитени навсякъде с нашето мощно мобилно приложение',
      heading: 'Проследявайте активността на мълниите и останете в безопасност',
      description: 'Нашето мобилно приложение предоставя незабавни известия за удари от мълнии във вашия район, помагайки ви да вземате навременни решения за безопасност, независимо дали сте на поход в планината, на къмпинг или се наслаждавате на дейности на открито на Балканите.',
      highlight: 'Следете активността на мълниите в реално време и получавайте незабавни известия, когато удари бъдат засечени близо до вашето местоположение.',
      downloadIos: 'Изтеглете за iOS',
      downloadAndroid: 'Изтеглете за Android',
      comingSoon: 'Очаквайте скоро',
    },
    benefits: {
      title: 'Защо да изберете SkyRadar',
      reliability: 'Ненадмината надеждност',
      reliabilityDescription: 'Гаранция за 99,9% време на работа с резервни системи за непрекъсната работа',
      accuracy: 'Превъзходна точност',
      accuracyDescription: 'Прецизна технология за откриване с минимални фалшиви положителни резултати',
      scalability: 'Напълно мащабируемо',
      scalabilityDescription: 'От единичен обект до глобално корпоративно внедряване с постоянна производителност',
      support: 'Отдадена поддръжка',
      supportDescription: '24/7 техническа помощ от нашия екип от експерти',
    },
    testimonials: {
      title: 'Какво казват нашите клиенти',
      client1: {
        quote: 'SkyRadar трансформира начина, по който управляваме рисковете, свързани с времето, в нашите съоръжения. Известията в реално време ни помогнаха да предотвратим няколко потенциални инцидента.',
        author: 'Иван Петров',
        position: 'Директор по безопасността, Global Energy Corp'
      },
      client2: {
        quote: 'Възможностите за интеграция са впечатляващи. Свързахме SkyRadar с нашите съществуващи системи за сигурност само за дни, не месеци.',
        author: 'Мария Родригес',
        position: 'Технически директор, Industrial Solutions Inc.'
      },
      client3: {
        quote: 'Аналитиката, предоставена от SkyRadar, ни помогна да оптимизираме нашите графици за поддръжка и да подобрим оперативната ефективност.',
        author: 'Димитър Чен',
        position: 'Оперативен мениджър, National Grid Services'
      }
    },
    pricing: {
      title: 'Гъвкави решения за всяка нужда',
      description: 'Предлагаме персонализирани пакети, съобразени с вашите специфични изисквания и мащаб.',
      basic: 'Базов',
      basicDescription: 'За малки бизнеси и операции на един обект',
      professional: 'Професионален',
      professionalDescription: 'За средни бизнеси с множество локации',
      enterprise: 'Корпоративен',
      enterpriseDescription: 'За големи организации със сложни изисквания',
      contact: 'Свържете се с нас за ценообразуване',
      contactSales: 'Свържете се с отдел продажби',
      mostPopular: 'Най-популярен',
    },
    about: {
      title: 'Възможности за интеграция',
      description: 'Ако искате да получавате информация за мълнии или да се интегрирате с вашите услуги, ние предлагаме гъвкави решения за всякакви нужди. Нашите API и инструменти за интеграция правят лесно свързването на данни за мълнии към вашите съществуващи системи.',
      mission: 'Стремим се да направим данните за мълнии достъпни за всички чрез прости и надеждни интеграции с всякакви услуги и платформи.',
    },
    footer: {
      rights: 'Всички права запазени',
      privacy: 'Политика за поверителност',
      terms: 'Условия за ползване',
      quickLinks: 'Бързи връзки',
      contactUs: 'Свържете се с нас',
      email: 'Имейл: info@skyradar.com',
    },
    partners: {
      title: 'Нашите партньори',
      subtitle: 'Гордеем се със сътрудничеството с тези организации, които правят нашата мисия възможна',
      icdsoft: 'ICDSoft',
      icdsoftDescription: 'Основен партньор за хостинг и инфраструктура',
      firebrigade: 'FireBrigade1',
      firebrigadeDescription: 'Партньор за сътрудничество с аварийни служби',
    },
    dataProcessing: {
      title: 'Мощна обработка на данни',
      description1: 'Нашата система обработва стотици хиляди събития с мълнии ежедневно в целия Балкански регион, предоставяйки данни в реално време и аналитика, за да помогне за защитата на общностите и природните ресурси.',
      description2: 'Чрез напреднали алгоритми и специализирана инфраструктура, ние анализираме всеки удар от мълния, за да определим неговото местоположение, интензитет и потенциални рискови фактори, позволявайки по-бързо време за реакция на аварийните служби.',
      feature1: 'Обработка в реално време на над 100 000 събития дневно',
      feature2: 'Прецизно географско картографиране на ударите от мълнии',
      feature3: 'Автоматизирана система за оценка на риска и известяване',
    },
    mobileAppFeatures: {
      feature1: 'Известия за удари от мълнии в реално време',
      feature1Description: 'Получавайте сигнали, когато мълния е засечена близо до вашето местоположение',
      feature2: 'Интерактивна карта на мълниите с филтри',
      feature2Description: 'Визуализирайте активността на мълниите с персонализируеми филтри',
      feature3: 'Персонализируем радиус на известията и настройки',
      feature3Description: 'Задайте предпочитаното разстояние за известия и типове сигнали',
      feature4: 'Прогнози за времето с оценка на риска от мълнии',
      feature4Description: 'Планирайте дейностите си с прогнози за риска от мълнии',
      feature5: 'Работи офлайн с кеширани данни',
      feature5Description: 'Достъп до последните данни дори без интернет връзка',
    },
    sensorInfrastructure: {
      title: 'Персонализирана инфраструктура на сензорите',
      description: 'Търсите персонализирано решение за събиране на данни от сензори за мълнии или метеорологични станции? Ние предоставяме цялостна настройка на инфраструктурата за организации, които се нуждаят от надеждни системи за събиране на данни за мълнии и време.',
      quote: 'От инсталирането на хардуер до събирането и анализа на данни, нашият екип от експерти ще проектира и внедри персонализирано решение, което отговаря на вашите специфични изисквания.',
      learnMore: 'Научете повече',
      page: {
        hero: {
          title: 'Персонализирани решения за инфраструктура на сензори',
          subtitle: 'Откриване на мълнии и мониторинг на времето, съобразени с вашите нужди',
          description: 'Търсите персонализирано решение за събиране на данни от сензори за мълнии или метеорологични станции? Нашият екип предоставя цялостна настройка на инфраструктурата, от инсталиране на хардуер до събиране и анализ на данни.',
          contactButton: 'Свържете се с нас сега'
        },
        benefits: {
          title: 'Защо да изберете нашата инфраструктура на сензори',
          subtitle: 'Ние предоставяме цялостни решения за организации, които се нуждаят от надеждни системи за събиране на данни за мълнии и време',
          items: {
            lightningDetection: {
              title: 'Напреднало откриване на мълнии',
              description: 'Нашите сензори осигуряват прецизно откриване на мълнии с висока точност и минимални фалшиви положителни резултати.'
            },
            weatherMonitoring: {
              title: 'Цялостен мониторинг на времето',
              description: 'Наблюдавайте температура, влажност, скорост на вятъра, валежи и други с нашите интегрирани метеорологични сензори.'
            },
            integration: {
              title: 'Лесна интеграция',
              description: 'Нашата инфраструктура се интегрира лесно с вашите съществуващи системи чрез стандартни API и протоколи.'
            },
            dataCollection: {
              title: 'Надеждно събиране на данни',
              description: 'Стабилни решения за събиране и съхранение на данни гарантират, че вашите данни са винаги налични, когато имате нужда от тях.'
            },
            analytics: {
              title: 'Анализ в реално време',
              description: 'Обработвайте и анализирайте данни от сензори в реално време, за да вземате информирани решения бързо.'
            },
            management: {
              title: 'Дистанционно управление',
              description: 'Наблюдавайте и управлявайте вашата сензорна мрежа дистанционно чрез нашия интуитивен панел.'
            }
          }
        },
        process: {
          title: 'Нашият цялостен процес',
          subtitle: 'От консултация до внедряване и текуща поддръжка',
          steps: {
            step1: {
              title: 'Консултация и анализ на изискванията',
              description: 'Започваме с разбиране на вашите специфични нужди, предизвикателства и цели. Нашият екип от експерти ще работи с вас, за да идентифицира оптималната конфигурация на сензорите и настройката на инфраструктурата за вашия случай на употреба.'
            },
            step2: {
              title: 'Дизайн на персонализирано решение',
              description: 'Въз основа на вашите изисквания, ние проектираме персонализирано решение, което включва избор на хардуер, мрежова архитектура, протоколи за събиране на данни и интеграция с вашите съществуващи системи.'
            },
            step3: {
              title: 'Внедряване и разгръщане',
              description: 'Нашият опитен екип се занимава с инсталирането и конфигурирането на всички хардуерни и софтуерни компоненти. Ние осигуряваме правилно калибриране и тестване, за да гарантираме точно събиране на данни.'
            },
            step4: {
              title: 'Интеграция на данни и анализ',
              description: 'Ние настройваме тръбопроводи за обработка на данни, решения за съхранение и инструменти за анализ, за да трансформираме необработените данни от сензори в действени прозрения. Персонализирани табла и отчети осигуряват лесен достъп до вашите данни.'
            },
            step5: {
              title: 'Текуща поддръжка и обслужване',
              description: 'Нашата връзка не приключва с разгръщането. Ние предоставяме цялостна поддръжка, редовна поддръжка и актуализации на системата, за да гарантираме, че вашата инфраструктура продължава да работи оптимално.'
            }
          }
        },
        useCases: {
          title: 'Индустриални приложения',
          subtitle: 'Нашите решения за инфраструктура на сензори обслужват различни индустрии със специфични нужди',
          items: {
            energy: {
              title: 'Енергиен сектор',
              description: 'Защитете инфраструктурата за производство и разпределение на енергия от удари от мълнии и тежки метеорологични условия.'
            },
            aviation: {
              title: 'Авиация',
              description: 'Осигурете безопасни излитания и кацания с точни данни за мълнии и време за летища.'
            },
            agriculture: {
              title: 'Земеделие',
              description: 'Оптимизирайте земеделските операции с прецизни прогнози за времето и предупреждения за мълнии.'
            },
            sports: {
              title: 'Спорт и отдих',
              description: 'Поддържайте събития и дейности на открито безопасни с навременни предупреждения за времето и мълнии.'
            }
          }
        },
        whyUs: {
          title: 'Защо да си партнирате с нас',
          items: {
            expertise: {
              title: 'Индустриален опит',
              description: 'Нашият екип има десетилетия комбиниран опит в метеорологията, сензорните технологии и науката за данни.'
            },
            trackRecord: {
              title: 'Доказан опит',
              description: 'Успешно сме внедрили сензорни мрежи за организации в множество индустрии по целия свят.'
            },
            technology: {
              title: 'Съвременна технология',
              description: 'Използваме най-новите постижения в сензорната технология, IoT и облачните изчисления, за да предоставим превъзходни решения.'
            },
            approach: {
              title: 'Персонализиран подход',
              description: 'Не вярваме в универсални решения. Всяка система, която проектираме, е съобразена с вашите специфични изисквания.'
            },
            support: {
              title: 'Текуща поддръжка',
              description: 'Нашият отдаден екип за поддръжка гарантира, че вашата инфраструктура продължава да работи с максимална производителност.'
            }
          }
        },
        contact: {
          title: 'Свържете се с нас',
          subtitle: 'Интересувате се от нашите решения за инфраструктура на сензори? Свържете се с нас днес, за да обсъдим вашите нужди.',
          email: 'Изпратете ни имейл директно на',
          emailAddress: 'infrastructure@skyradar.com'
        }
      }
    },
    cta: {
      title: 'Готови ли сте да защитите активите си от опасностите на мълниите?',
      description: 'Свържете се с нашия екип днес, за да научите как SkyRadar може да помогне на вашата организация да внедри цялостна стратегия за защита от мълнии.',
      button: 'Свържете се с нас сега',
    },
    companyDescription: 'Решения за откриване и мониторинг на мълнии от корпоративен клас за бизнеси и организации по целия свят.',
    thunderBG: {
      title: 'ThunderBG',
      subtitle: 'Доброволчески проект за събиране на данни за мълнии на Балканите',
      description: 'ThunderBG е доброволческа инициатива, посветена на събирането на данни за мълнии в Балканския регион. Нашата мисия е да предоставяме информация за мълнии в реално време, за да помогнем на противопожарните служби да реагират бързо на потенциални горски пожари и да помогнем на туристите да останат в безопасност по време на дейности на открито.',
      viewDemo: 'Вижте демо',
    },
    getStarted: 'Започнете',
  },
  header: {
    main: 'Начало',
    map: 'Карта',
    contact: 'Контакти',
    sensorInfrastructure: 'Инфраструктура на сензорите',
    language: 'Език',
    about: 'За нас',
  },
  contact: {
    title: 'Свържете се с нас',
    subtitle: 'Свържете се с нашия екип',
    description: 'Ние предоставяме цялостни решения за събиране на данни от сензори, анализ, разработка на приложения и интеграции. Ако имате сензори, но нямате инфраструктура, можем да помогнем за решаването на този проблем.',
    form: {
      name: 'Име',
      email: 'Имейл',
      company: 'Компания',
      message: 'Съобщение',
      subject: 'Тема',
      phone: 'Телефон (по избор)',
      submit: 'Изпрати',
      sending: 'Изпращане на вашето съобщение...',
      success: 'Благодарим за вашето съобщение! Ще се свържем с вас скоро.',
      error: 'Възникна грешка при изпращането на вашето съобщение. Моля, опитайте отново по-късно.',
      nameRequired: 'Моля, въведете вашето име',
      emailRequired: 'Моля, въведете вашия имейл',
      emailInvalid: 'Моля, въведете валиден имейл',
      messageRequired: 'Моля, въведете съобщение',
      subjectRequired: 'Моля, въведете тема',
      notificationTitle: 'Ново подаване на контактна форма:',
      notificationName: 'Име:',
      notificationEmail: 'Имейл:',
      notificationCompany: 'Компания:',
      notificationPhone: 'Телефон:',
      notificationSubject: 'Тема:',
      notificationMessage: 'Съобщение:',
    },
    services: {
      title: 'Нашите услуги',
      dataCollection: 'Събиране на данни',
      dataAnalysis: 'Анализ на данни',
      aiDevelopment: 'Разработка на ИИ',
      appDevelopment: 'Разработка на приложения',
      integrations: 'Персонализирани интеграции',
    },
  },
  map: {
    title: 'Карта на мълниите',
    legend: 'Легенда на картата',
    lightning: 'Мълния',
    recent: 'Мълнии през последните 5 минути',
    medium: 'Мълнии през последните 30 минути',
    old: 'Мълнии по-стари от 30 минути',
    helpTitle: 'Как да използвате картата',
    helpText1: 'Използвайте контролите вдясно за увеличаване/намаляване и намиране на вашето местоположение.',
    helpText2: 'Филтрирайте събитията с мълнии по време, използвайки бутона за филтър.',
    helpText3: 'Кликнете върху иконите на мълнии за повече подробности за всеки удар.',
    filter: 'Филтър на събития с мълнии',
    timeRange: 'Времеви диапазон',
    minutes10: 'Последните 10 минути',
    hour1: 'Последния час',
    hours6: 'Последните 6 часа',
    hours24: 'Последните 24 часа',
    apply: 'Приложи',
    loading: 'Зареждане на картата...',
    error: 'Грешка при зареждане на данните. Моля, опитайте отново.',
    noData: 'Няма намерени събития с мълнии в тази област за избрания времеви диапазон.',
    controls: {
      zoomIn: 'Увеличи',
      zoomOut: 'Намали',
      myLocation: 'Моето местоположение',
      info: 'Информация за картата',
      yourLocation: 'Вашето местоположение'
    },
    filters: {
      last10min: 'Последните 10 минути',
      lastHour: 'Последния час',
      last6hours: 'Последните 6 часа',
      last24hours: 'Последните 24 часа',
      filter: 'Филтър',
      openFilters: 'Отвори филтрите',
      filterLightningEvents: 'Филтриране на събития с мълнии',
      closeFilters: 'Затвори филтрите',
      currentFilter: 'Текущ филтър',
      none: 'Няма',
      selectTimeRange: 'Избери времеви диапазон',
      cancel: 'Отказ',
      apply: 'Приложи'
    }
  },
};
